import { Navigate } from 'react-router-dom';
import { estSuperAdmin, fermerSession, lireJeton } from '../api/role';

interface Props { children: JSX.Element; superAdmin?: boolean; }

const PrivateRoute = ({ children, superAdmin = false }: Props) => {
  const token = sessionStorage.getItem('jwtToken');
  if (!token) return <Navigate to="/sign_in" replace />;
  const lu = lireJeton(token);
  // Jeton illisible ou expiré : déconnexion, jamais de rôle par défaut.
  if (!lu || (lu.exp !== null && lu.exp * 1000 < Date.now())) {
    fermerSession();
    return <Navigate to="/sign_in" replace />;
  }
  // Affichage seulement : le serveur impose le rôle sur chaque appel.
  if (superAdmin && !estSuperAdmin()) return <Navigate to="/home" replace />;
  return children;
};
export default PrivateRoute;
